module.exports = __webpack_public_path__ + "static/media/2032en.b33ed689.svg";